<template>
  <div
    :class="dropShopClass"
    :style="getCustomStyle"
    @click="selectDropShopById(dropShop.id)">
    <div :style="{color:pageTextColor}">
      <div class="c-cbr-MapOverlay-dropShopName">
        <img
          v-if="dropShop.parcelShopLogoUrl"
          :class="$style.shopIcon"
          :src="dropShop.parcelShopLogoUrl"
        >
      </div>
      <div>{{ dropShop.name.replace("null", "") }}</div>
      <div>{{ dropShop.address.street.replace("null", "") }}</div>
      <div>{{ dropShop.address.zipCode.replace("null", "") }} {{ dropShop.address.city.replace("null", "") }}</div>
      <div
        v-if="dropShop.openingHoursSummary && dropShop.openingHoursSummary.length"
        style="margin-top: 0.5em;"
        class="c-cbr-MapOverlay-dropShopOpeningHours"
      >
        <cbr-drop-shop-opening-hours :drop-shop="dropShop" />
      </div>
    </div>
    <div style="text-align: center;">
      <div class="c-cbr-MapOverlay-resultsMarkerIcon">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 28 38"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"
        >
          <rect
            id="pin"
            x="0"
            y="0"
            width="27.143"
            height="38"
            style="fill:none;" />
          <clipPath id="_clip1">
            <rect
              x="0"
              y="0"
              width="27.143"
              height="38" />
          </clipPath>
          <g clip-path="url(#_clip1)">
            <g
              id="pin1"
              serif:id="pin">
              <rect
                id="EXPORT"
                x="-2352.67"
                y="-1805.5"
                width="6611.8"
                height="5215.4"
                style="fill:none;"
              />
              <path
                :style="getStyle"
                d="M13.6,0.5c-7.242,0 -13.1,5.745 -13.1,12.848c0,9.636 13.1,23.861 13.1,23.861c0,0 13.1,-14.225 13.1,-23.861c0,-7.103 -5.858,-12.848 -13.1,-12.848Z"
              />
            </g>
          </g>
          <text
            :fill="getFill"
            text-anchor="middle"
            x="13"
            y="21"
            font-size="14px"
          >{{ dropShop.index }}</text>
        </svg>
      </div>
      <div :style="{color:pageTextColor}">{{ dropShop.distance | distance }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CbrDropShopOpeningHours from './CbrDropShopOpeningHours.vue'

export default {
  components: { CbrDropShopOpeningHours },
  props: {
    dropShop: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('config', [
      'buttonColor',
      'buttonTextColor',
      'pageTextColor',
      'parcelShopInfoBackgroundColor'
    ]),
    dropShopClass() {
      return this.selected
        ? [this.$style.dropShop, 'c-cbr-MapOverlay-selectedDropShop']
        : [this.$style.dropShop, 'c-cbr-MapOverlay-dropShopResult']
    },
    getCustomStyle() {
      return this.selected
        ? { backgroundColor: this.parcelShopInfoBackgroundColor }
        : ''
    },
    resultsMarkerIconClass() {
      return this.selected
        ? 'c-cbr-MapOverlay-resultsMarkerIconSelected'
        : 'c-cbr-MapOverlay-resultsMarkerIcon'
    },

    resultsMarkerNumberClass() {
      return this.selected
        ? 'c-cbr-MapOverlay-resultsMarkerNumberSelected'
        : 'c-cbr-MapOverlay-resultsMarkerNumber'
    },
    getStyle() {
      let dropShopStyle =
        'fill:#6b1544;fill-rule:nonzero;stroke:#6b1544;stroke-width:1px;'
      let dropShopSelectedStyle =
        'fill: #FFF;fill-rule:nonzero;stroke:#6b1544;stroke-width:1.5px;'

      if (this.selected) {
        if (this.buttonColor !== '') {
          dropShopStyle =
            'fill:' +
            this.buttonColor +
            ';fill-rule:nonzero;stroke:' +
            this.buttonColor +
            ';stroke-width:1px;'
        }

        return dropShopStyle
      } else {
        if (this.buttonColor !== '') {
          dropShopSelectedStyle =
            'fill: #FFF;fill-rule:nonzero;stroke:' +
            this.buttonColor +
            ';stroke-width:1.5px;'
        }
        return dropShopSelectedStyle
      }
    },
    getFill() {
      let dropshopFill = 'white'
      let dropshopSelectedFill = '#6b1544'

      if (this.selected) {
        if (this.buttonTextColor !== '') {
          dropshopFill = this.buttonTextColor
        }
        return dropshopFill
      } else {
        if (this.buttonTextColor !== '') {
          dropshopSelectedFill = '#000000'
        }
        return dropshopSelectedFill
      }
    }
  },

  methods: {
    ...mapActions('dropShops', ['selectDropShopById'])
  }
}
</script>

<style module>
.dropShop {
  display: grid;
  grid-template-columns: 1fr 60px;
}

.shopIcon {
  max-height: 50px;
  max-width: auto;
}
</style>



// WEBPACK FOOTER //
// client/components/drop-shop/CbrDropShopMini.vue